import { X } from 'lucide-react'
import MessageList from '../../pages/clients/message/MessageList'
import ChatConversation from '../../pages/clients/message/ChatConversation'

const MobileMessaging = ({mobileView,handleBackToList,handleSelectChat,
    selectedChatId,handleProfileView}) => {
  return (
    <div className="h-screen flex flex-col bg-white dark:bg-[#0b0e14] font-['Poppins']">
         {/* Mobile header with conditional back button */}
         {mobileView === 'profile' && (
           <div className="bg-white dark:bg-[#0b0e14] p-4 flex items-center border-b dark:border-[#1d2026]">
             <button 
               onClick={handleBackToList}
               className="mr-4"
             >
               <X size={24} />
             </button>
             
             <h1 className="text-[14px] font-medium dark:text-white">Profile</h1>
           </div>
         )}
         
         {/* Mobile views */}
         {mobileView === 'list' && (
           <div className="flex-1 overflow-hidden">
             <MessageList 
               onSelectChat={handleSelectChat}
               selectedChatId={selectedChatId}
               isMobile={true}
             />
           </div>
         )}
         
         {mobileView === 'chat' && (
           <div className="flex-1 overflow-hidden">
             <ChatConversation 
               onClose={handleBackToList}
               onProfileView={handleProfileView}
               isMobile={true}
             />
           </div>
         )}
         
        
       </div>
  )
}

export default MobileMessaging